import {Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {NotificationsService} from '../../../services/notifications.service';
import {AccountService} from '../../../services/account.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CustomerDetail} from '../../../domain/customer/customer-detail';
import {Account} from '../../../domain/accounts/account';
import {ITargetAccount} from '../../../domain/accounts/ITargetAccount';
import {ETargetAccountType} from '../../../enums/ETargetAccountType';
import {ETransferType} from '../../../enums/ETransferType';
import * as moment from 'moment';
import {TargetAccountEntity} from '../../../entity/TargetAccountEntity';
import {Router} from '@angular/router';
import html2canvas from 'html2canvas';
import * as FileSaver from 'file-saver';
import {ToastaService} from 'ngx-toasta';
import {TranslateService} from '@ngx-translate/core';
import {CustomerDetailService} from '../../../services/customer-detail.service';
import {CustomerProfile} from '../../../domain/customer/customer-profile';
import {CustomerProfileService} from '../../../services/customer-profile.service';
import {AccountConfiguration} from '../../../domain/configurations';
import {ConfigurationService} from '../../../services/configuration.service';
import {DialogService} from 'primeng/dynamicdialog';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ReCaptchaV3Service} from 'ng-recaptcha';

@Component({
  selector: 'app-transfers',
  templateUrl: './transfers.component.html',
  styleUrls: ['./transfers.component.scss']
})
export class TransfersComponent extends CommonComponent implements OnInit, OnDestroy {
  @ViewChild('PRE_DISCLOSURE') PRE_DISCLOSURE: ElementRef;
  today: string = moment().format('DD MMM YYYY');
  customerDetail: CustomerDetail = new CustomerDetail();
  targetAccounts: ITargetAccount[] = [];
  balance: number;
  targetAccountType: ETargetAccountType = null;
  transferType: ETransferType = null;
  targetAccount: ITargetAccount = new TargetAccountEntity();
  transferAmount: number = 0;
  transferFees = 0;
  exchangeRate = 0;
  recurrentName: string = null;
  confirmationCode: string = null;
  sendToEmail: string = null;
  showTargetAccounts = true;
  showTransfer = false;
  showPreDisclosure = false;
  showDisclosure = false;
  showOtp = false;
  applicationId: number;
  nationalTransf = false;
  internationalTransf = false;
  otpLength = 6;
  missingExchangeRate: boolean;
  missingTransferFee: boolean;
  deletingAccount: any = null;
  deletingAccountIndex: number = null;
  customerProfile: CustomerProfile;
  configurations: AccountConfiguration;
  transferFee: any[];
  displayDelete =  false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  isDropdownOpen: boolean[] = [];

  constructor(
    private accountsService: AccountService,
    private customerDetailService: CustomerDetailService,
    private customerProfileService: CustomerProfileService,
    protected router: Router,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    private configurationsService: ConfigurationService,
    protected dialogService: DialogService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.configurations = this.configurationsService.account;
  }

  ngOnInit(): void {
    this.getTargetAccounts();
    this.getCustomerDetail();
    this.getCustomerProfile();
    this.getTransactionFee();
    if (this.configurations.enableInternationalTransfers === false && this.configurations.enableInternalTransfers === false) {
      this.router.navigateByUrl('account/balance');
    }
  }

  getCustomerProfile() {
    this.customerProfileService.customerProfile$.pipe(takeUntil(this.destroyed$)).subscribe(
      (response: any) => {
        this.customerProfile = response;
      }, error => {
        this.msgError(error);
      }
    );
  }
  getCustomerDetail() {
    this.customerDetailService.customerDetail$.pipe(takeUntil(this.destroyed$)).subscribe(
      (response: any) => {
        this.customerDetail = response;
        this.getBalance(this.customerDetail?.account);
      }, error => {
        this.loadingModalOff();
        switch (error.status) {
          case 409:
            break;
          default:
            this.msgError(error, $localize`Ocurrió un error al obtener tus datos`);
            break;
        }
      }
    );
  }
  getTransactionFee() {
    this.accountsService.getTransferFees('internal').subscribe(
      (response: any) => {
        this.transferFee = response;
      }, error => {
        this.msgError(error);
      }
    );
  }

  getExchangeRate() {
    if (this.configurations.enableInternationalTransfers){
      this.accountsService.getExchangeRate().subscribe(
        (response: any) => {
          this.exchangeRate = response.exchangeRate;
          this.missingExchangeRate = false;
        }, error => {
          this.missingExchangeRate = true;
          this.msgError(error);
        }
      );
    }
  }

  getBalance(account: Account) {
    this.accountsService.getBalance(account.id).subscribe(
      (response: any) => {
        this.balance = response.balance;
      }, error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }

  onSubmit() {
    switch (this.transferType) {
      case ETransferType.INTERNAL:
        this.generateRecaptcha();
        break;
      case ETransferType.INTERNATIONAL:
        this.showTransfer = false;
        this.showPreDisclosure = true;
        break;
    }

  }
  generateRecaptcha(){
    this.recaptchaV3Service.execute('send_otp').subscribe((token) => {
        this.transfer(token);
      }, error => {
        this.msgError(error, this.translate.instant('shared.common.general_error_message'));
      }
    );
  }

  transfer(token: string) {
    this.loadingModalOn();
    this.accountsService.transfer(this.customerDetail?.account, this.targetAccount, this.transferAmount,
      token, this.recurrentName).subscribe(
      (response: any) => {
        if (this.targetAccountType === this.eTargetAccountTypes.INTERNATIONAL) {
          this.showTransfer = false;
          this.showPreDisclosure = false;
          this.showOtp = true;
          this.internationalTransf = true;
        } else {
          this.showTransfer = false;
          this.showOtp = true;
          this.nationalTransf = true;
        }
        this.applicationId = response.confirmationId;
        this.loadingModalOff();
      },
      error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }

  transferDataUpdate(targetAccount: ITargetAccount) {
    this.targetAccount = targetAccount;
    this.showTargetAccounts = false;
    switch (targetAccount.type) {
      case ETargetAccountType.INTERNAL_CARD:
        this.transferType = ETransferType.INTERNAL;
        this.targetAccountType = this.eTargetAccountTypes.INTERNAL_CARD;
        break;
      case ETargetAccountType.INTERNATIONAL:
        this.transferType = ETransferType.INTERNATIONAL;
        this.targetAccountType = this.eTargetAccountTypes.INTERNATIONAL;
        break;
    }
  }

  openModal(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  downloadPreDisclosure() {
    html2canvas(document.querySelector('#PRE_DISCLOSURE')).then(canvas => {
      canvas.toBlob(function callback(blob) {
        FileSaver.saveAs(blob, `Pre_disclosure.jpg`);
      });
    });
  }

  sendPreDisclosure() {
    html2canvas(document.querySelector('#PRE_DISCLOSURE')).then(canvas => {
      const img = canvas.toDataURL('image/png');
      this.sendDisclosureEmail(img, 'Pre_disclosure');
    });
  }

  downloadDisclosure() {
    html2canvas(document.querySelector('#DISCLOSURE')).then(canvas => {
      canvas.toBlob(function callback(blob) {
        FileSaver.saveAs(blob, `Disclosure.jpg`);
      });
    });
  }

  sendDisclosure() {
    html2canvas(document.querySelector('#DISCLOSURE')).then(canvas => {
      const img = canvas.toDataURL('image/png');
      this.sendDisclosureEmail(img, 'Disclosure');
    });
  }


  sendDisclosureEmail(file: string, fileName: string) {
    this.loadingModalOn();
    this.accountsService.sendDisclosureEmail(this.sendToEmail, fileName, file).subscribe(
      (response: any) => {
        this.loadingModalOff();
        this.msgSuccess($localize`Archivo enviado satisfactoriamente`);
        this.sendToEmail = null;
      },
      error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }

  balanceNavigate() {
    this.router.navigate(['account/balance']);
  }

  sendTransferConfirm(otp) {
    if (this.showOtp && otp.length === this.otpLength) {
      this.loadingModalOn();
      this.showOtp = false;
      this.accountsService.transferConfirm(this.applicationId, otp).subscribe(
        (response: any) => {
          if (this.internationalTransf) {
            this.showOtp = false;
            this.showDisclosure = true;
            this.internationalTransf = false;
            this.confirmationCode = response.transactionNumber;
            this.loadingModalOff();
            this.msgSuccess($localize`:@@transferSuccess:Transferencia realizada correctamente`);
          }
          if (this.nationalTransf) {
            this.loadingModalOff();
            this.nationalTransf = false;
            this.msgSuccess($localize`:@@transferSuccess:Transferencia realizada correctamente`);
            this.router.navigate(['/account/balance']);
          }
        },
        error => {
          this.loadingModalOff();
          this.showOtp = false;
          this.showTransfer = true;
          this.msgError(error);
        }
      );
    }
  }


  getTargetAccounts() {
    this.loadingModalOn();
    this.accountsService.getTargetAccounts([this.eTargetAccountStatus.ACTIVE]).subscribe(
      (response: any) => {
        this.targetAccounts = response;
        if (this.targetAccounts.length === 0){
          this.router.navigateByUrl('account/targetAccount/NEW');
        }
        this.getInternationalAccounts();
      },
      error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }

  getInternationalAccounts() {
    this.accountsService.getInternationalTargetAccounts().subscribe(
      (response: any) => {
        for (const ta of response) {
          ta.alias = `${ta.firstName} ${ta.middleName ? ta.middleName : ''} ${ta.lastName} ${ta.secondaryLastName ? ta.secondaryLastName : ''}`.trim();
        }
        for (const account of response) {
          account.type = this.eTargetAccountTypes.INTERNATIONAL;
        }
        this.targetAccounts = this.targetAccounts.concat(response);
        this.loadingModalOff();
      },
      error => {
        this.loadingModalOff();
        switch (error.status) {
          case 422:
            this.msgError(error, $localize`Código inválido`);
            break;
          default:
            this.msgError($localize`Ocurrió un error con tu solicitud`);
        }
      }
    );
  }

  deleteAccount() {
    this.loadingModalOn();
    switch (this.deletingAccount.type) {
      case ETargetAccountType.INTERNAL_CARD:
        this.accountsService.deleteTargetAccount(this.deletingAccount).subscribe(
          (response: any) => {
            this.loadingModalOff();
            this.targetAccounts.splice(this.deletingAccountIndex, 1);
            this.msgSuccess($localize`Cuenta eliminada correctamente`);
          },
          error => {
            this.loadingModalOff();
            switch (error.status) {
              case 422:
                this.msgError(error, $localize`Código inválido`);
                break;
              default:
                this.msgError($localize`Ocurrió un error con tu solicitud`);
            }
          }
        );
        break;
      case ETargetAccountType.INTERNATIONAL:
        this.accountsService.deleteInternationalTargetAccount(this.deletingAccount).subscribe(
          (response: any) => {
            this.loadingModalOff();
            this.targetAccounts.splice(this.deletingAccountIndex, 1);
            this.msgSuccess($localize`Cuenta eliminada correctamente`);
          },
          error => {
            this.loadingModalOff();
            switch (error.status) {
              case 422:
                this.msgError(error, $localize`Código inválido`);
                break;
              default:
                this.msgError($localize`Ocurrió un error con tu solicitud`);
            }
          }
        );
        break;
      default:
        this.loadingModalOff();
        this.msgError($localize`Ocurrió un error con tu solicitud`);
    }
  }
  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }

  maskedNumber(accountNumber: string): string {
    if (!accountNumber || accountNumber.length <= 4) {
      return accountNumber;
    }
    return ` •••• ${accountNumber.slice(-4)}`;
  }

  toggleDropdown(index: number) {
    this.isDropdownOpen[index] = !this.isDropdownOpen[index];
  }

  isAnyDropdownOpen(): boolean {
    return this.isDropdownOpen.some(open => open);
  }

  closeAllDropdowns() {
    this.isDropdownOpen = this.isDropdownOpen.map(() => false);
  }

}
